export const emptyRichTextText = {
  detail: 0,
  format: 0,
  mode: 'normal',
  style: '',
  text: '',
  type: 'text',
  version: 1,
};

export const emptyRichTextParagraph = {
  children: [],
  direction: 'ltr',
  format: '',
  indent: 0,
  type: 'paragraph',
  version: 1,
};

const defaultRichText = {
  root: {
    children: [{
      ...emptyRichTextParagraph,
      children: [emptyRichTextText],
    }],
    direction: 'ltr',
    format: '',
    indent: 0,
    type: 'root',
    version: 1,
  },
};
export default defaultRichText;
